import React from "react";

import { TagType, _Tag } from "./_Tag";

export function DangerTag({
  type = "bold",
  testID = "danger-tag",
  ...props
}: TagType) {
  if (type === "bold")
    return (
      <_Tag
        fill="background-accent-red-strong"
        color="text-accent-red-weak"
        testID={testID}
        {...props}
      />
    );

  return (
    <_Tag
      fill="background-accent-red-weak"
      color="text-accent-red-strong"
      testID={testID}
      {...props}
    />
  );
}
